(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5376],{

/***/ 9697:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[slug]",
      function () {
        return __webpack_require__(94814);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* reexport */ FixedPageTemplate; }
});

// UNUSED EXPORTS: fixedPageDataFetcher

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
// EXTERNAL MODULE: ./src/features/collector/index.js + 4 modules
var collector = __webpack_require__(11871);
// EXTERNAL MODULE: ./src/shared/utils/index.js + 10 modules
var utils = __webpack_require__(63414);
// EXTERNAL MODULE: ./src/components/templates/SinglePage/index.js + 2 modules
var SinglePage = __webpack_require__(16318);
;// CONCATENATED MODULE: ./src/components/templates/FixedPage/FixedPage.fetcher.js








var TEMPLATE_PATH = {
    "/events": "/event-template",
    "/courses": "/course-template",
    "/articles": "/article-template"
};
function fixedPageDataFetcher(context, options) {
    return _fixedPageDataFetcher.apply(this, arguments);
}
function _fixedPageDataFetcher() {
    _fixedPageDataFetcher = _async_to_generator(regeneratorRuntime.mark(function _callee(context, options) {
        var ref, locale, query, shouldDebugResponse, ref1, ref2, ref3, _props, data, error, debugData, templatedData, collectedData;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    locale = context.locale, query = context.query;
                    shouldDebugResponse = (context === null || context === void 0 ? void 0 : (ref = context.query) === null || ref === void 0 ? void 0 : ref._debugResponse) === "1";
                    _ctx.prev = 3;
                    ;
                    _ctx.next = 7;
                    return singlePageDataFetcher(context, {
                        path: options.path
                    });
                case 7:
                    ref3 = _ctx.sent;
                    _props = ref3.props;
                    data = _props.data;
                    error = _props.error;
                    debugData = _props.debugData;
                    _ctx.next = 14;
                    return fetchTemplatePageData({
                        locale: locale,
                        debug: shouldDebugResponse
                    }, TEMPLATE_PATH[options.path]);
                case 14:
                    templatedData = _ctx.sent.templatedData;
                    _ctx.next = 17;
                    return collectData({
                        items: _to_consumable_array(data.content).concat(_to_consumable_array(templatedData.content), _to_consumable_array(templatedData.hero)),
                        context: {
                            slug: query.slug,
                            date: (ref1 = data.pageOwnData) === null || ref1 === void 0 ? void 0 : ref1.date,
                            articleCategories: (ref2 = data.pageOwnData) === null || ref2 === void 0 ? void 0 : ref2.articleCategories
                        }
                    }, locale);
                case 17:
                    collectedData = _ctx.sent;
                    if (!(error && error.status === 204)) {
                        _ctx.next = 20;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        notFound: true
                    });
                case 20:
                    return _ctx.abrupt("return", {
                        props: {
                            data: data,
                            collectedData: collectedData,
                            templatedData: templatedData,
                            error: error,
                            debugData: debugData
                        }
                    });
                case 23:
                    _ctx.prev = 23;
                    _ctx.t0 = _ctx["catch"](3);
                    logError(_ctx.t0, _object_spread({
                        scope: "templatePageDataFetcher"
                    }, options !== null && options !== void 0 ? options : {}));
                    return _ctx.abrupt("return", {
                        props: {
                            data: {},
                            collectedData: {},
                            templatedData: {},
                            error: _ctx.t0,
                            debugData: {
                                error: {
                                    message: _ctx.t0.message,
                                    status: _ctx.t0.status
                                },
                                response: null,
                                scope: "Exception is caught inside during fetching a single page data"
                            }
                        }
                    });
                case 27:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                23
            ]
        ]);
    }));
    return _fixedPageDataFetcher.apply(this, arguments);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/ErrorWrapper/index.js + 1 modules
var ErrorWrapper = __webpack_require__(67638);
// EXTERNAL MODULE: ./src/components/Layout/index.js + 28 modules
var Layout = __webpack_require__(62569);
// EXTERNAL MODULE: ./src/components/Seo/index.js + 1 modules
var Seo = __webpack_require__(14934);
// EXTERNAL MODULE: ./src/components/WidgetsRenderer/index.js + 94 modules
var WidgetsRenderer = __webpack_require__(28986);
// EXTERNAL MODULE: ./src/shared/contexts/PageData/index.js + 3 modules
var PageData = __webpack_require__(65202);
// EXTERNAL MODULE: ./src/components/templates/FixedPage/FixedPage.module.scss
var FixedPage_module = __webpack_require__(60659);
var FixedPage_module_default = /*#__PURE__*/__webpack_require__.n(FixedPage_module);
;// CONCATENATED MODULE: ./src/components/templates/FixedPage/FixedPage.Template.jsx









var defaultDebugData = {};
function FixedPageTemplate(param) {
    var data = param.data, templatedData = param.templatedData, collectedData = param.collectedData, error = param.error, debugData = param.debugData;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorWrapper/* ErrorWrapper */.V, {
        error: error,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageData/* PageDataProvider */.Zz, {
            value: {
                data: data,
                collectedData: collectedData,
                debugData: debugData
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* Layout */.A, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* Seo */.p, {
                        data: templatedData.seo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetsRenderer/* WidgetsRenderer */.a, {
                        registry: "layout-widget",
                        items: templatedData.hero
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetsRenderer/* WidgetsRenderer */.a, {
                        registry: "content",
                        items: data.content,
                        className: classnames_default()((0,_define_property/* default */.Z)({}, (FixedPage_module_default())["article-wrapper"], (ref = data.pageOwnData) === null || ref === void 0 ? void 0 : ref.articleCategories))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WidgetsRenderer/* WidgetsRenderer */.a, {
                        registry: "layout-widget",
                        items: templatedData.content
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/components/templates/FixedPage/index.js




/***/ }),

/***/ 94814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var components_templates_FixedPage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19393);

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (components_templates_FixedPage__WEBPACK_IMPORTED_MODULE_0__/* .FixedPageTemplate */ .J);


/***/ }),

/***/ 60659:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"article-wrapper":"FixedPage_article-wrapper__Ok7MP"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1176,2569,6318,9774,2888,179], function() { return __webpack_exec__(9697); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);